export default __webpack_public_path__ + "static/logo_new-2b25ccdbdb9fac82d8828b53ab8ab2bf.png";